var app;

app = window.App || (window.App = {});

app.ElementToggler = (function() {
  function ElementToggler(checkbox) {
    this.checkbox = checkbox;
  }

  ElementToggler.prototype.hide = function() {
    var selector;
    selector = $(this.checkbox).data('hide');
    if (!$("#" + selector).is(':visible')) {
      return;
    }
    if (this.checkbox.checked) {
      return $("#" + selector).slideUp();
    } else {
      return $("#" + selector).slideDown();
    }
  };

  ElementToggler.prototype.show = function() {
    var selector;
    selector = $(this.checkbox).data('show');
    if ($("#" + selector).is(':visible')) {
      return;
    }
    if (this.checkbox.checked) {
      return $("#" + selector).slideDown();
    } else {
      return $("#" + selector).slideUp();
    }
  };

  ElementToggler.prototype.toggle = function(event) {
    var selector;
    selector = $(this.checkbox).data('hide');
    if ($("#" + selector).is(':visible')) {
      $("#" + selector).slideUp();
    } else {
      $("#" + selector).slideDown();
    }
    return event.preventDefault();
  };

  return ElementToggler;

})();

$(document).on('change', 'input[data-hide]', function(e) {
  return new app.ElementToggler(this).hide();
});

$(document).on('change', 'input[data-show]', function(e) {
  return new app.ElementToggler(this).show();
});

$(document).on('click', 'a[data-hide]', function(e) {
  return new app.ElementToggler(this).toggle(e);
});

$(document).on('turbo:load', function() {
  $('input[data-hide]').each(function(index, element) {
    return new app.ElementToggler(element).hide();
  });
  return $('input[data-show]').each(function(index, element) {
    return new app.ElementToggler(element).show();
  });
});
